// removed by extract-text-webpack-plugin
module.exports = {"calendar-select-modal":"calendar-select-modal","modal-fixed-height":"modal-fixed-height","modal-body":"modal-body","calendar-items":"calendar-items","calendar-select-item":"calendar-select-item"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/calendar-select-modal/calendar-select-modal.style.sass
// module id = p9qD
// module chunks = 0